import { LitElement, html } from 'lit';

import { StateController } from '../helpers/state/state-management/state-controller';
import accountInfo from '../helpers/state/account-info';
import { customElement } from 'lit/decorators';
import topicData from '../helpers/state/topic-data';

@customElement('upload-page')
export class UploadPage extends LitElement {
    amplitude_callsite: string = 'Upload Page';

    private readonly bindTopicState = new StateController(this, topicData);
    private readonly bindAccountState = new StateController(this, accountInfo);

    async firstUpdated() {
        await topicData.instantiateTopicData(this.amplitude_callsite, accountInfo.isAuthenticated, false, true);
        window.dispatchEvent(new CustomEvent('page-content-ready'));
    }

    render() {
        return html`
            <kml-upload-component></kml-upload-component>
            <error-toast id="errorToast"></error-toast>
        `;
    }
}
